// CSS
import "@/stylesheets/application.scss";
import "@/stylesheets/normalize.css";
import "@/stylesheets/style.css";
import "@/stylesheets/style_ticket_print.css";
// JS
import "@hotwired/turbo-rails";
import "@/controllers";
import * as common from "@/javascripts/common.js";
window.Common = common;
